export type BillingMode = 'annual' | 'monthly' | 'payg';

export function getBillingMode(
  params: Pick<URLSearchParams, 'get' | 'has'>,
): BillingMode {
  const explicitMode = params.get('billingMode');
  if (
    explicitMode === 'annual' ||
    explicitMode === 'monthly' ||
    explicitMode === 'payg'
  ) {
    return explicitMode;
  }

  if (params.has('isYearly')) {
    return params.get('isYearly') === 'true' ? 'annual' : 'monthly';
  }

  return 'payg';
}

export function setBillingMode(
  params: URLSearchParams,
  mode: Exclude<BillingMode, 'payg'>,
): void {
  params.set('billingMode', mode);
  params.set('isYearly', String(mode === 'annual'));
}
